import _ from "underscore";

export interface TagTypeMapping {
  type: string;
  tags: string[];
}

export const MARKS = {
  BOLD: {
    type: "bold",
    tags: [ "strong", "b" ],
  },
  ITALIC: {
    type: "italic",
    tags: [ "em", "i" ],
  },
  UNDERLINE: {
    type: "underline",
    tags: [ "u" ],
  },
};

export const INLINES = {
  LINK: {
    type: "link",
    tags: [ "a" ],
  },
  IMAGE: {
    type: "image",
    tags: [ "img" ],
  },
};

export const BLOCKS = {
  PARAGRAPH: {
    type: "paragraph",
    tags: [ "p" ],
  },
  QUOTE: {
    type: "quote",
    tags: [ "blockquote" ],
  },
  HEADING1: {
    type: "h1",
    tags: [ "h1" ],
  },
  HEADING2: {
    type: "h2",
    tags: [ "h2" ],
  },
  HEADING3: {
    type: "h3",
    tags: [ "h3" ],
  },
};

const buildTagLookup = (lookup: Record<string, TagTypeMapping>): Record<string, string> => _.object(_.chain(lookup)
  .values()
  .map(({ type, tags }: TagTypeMapping) => tags.map(tag => ([ tag, type ])))
  .flatten(true)
  .value());

export const MARK_TAG_LOOKUP = buildTagLookup(MARKS);
export const BLOCK_TAG_LOOKUP = buildTagLookup(BLOCKS);
export const INLINE_TAG_LOOKUP = buildTagLookup(INLINES);

export * from "./serialiserRules";
